(function () {
  function openPromoModal() {
    var modal = document.querySelector('#PromoBuy1Get2Modal');
    if (modal) modal.hidden = false;
  }

  function closePromoModal() {
    var modal = document.querySelector('#PromoBuy1Get2Modal');
    if (modal) modal.hidden = true;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('#ModalClose-PromoBuy1Get2')) {
      closePromoModal();
    }
    if (event.target.id === 'PromoBuy1Get2Modal') {
      closePromoModal();
    }
  });

  function getPromoQuantityInCart() {
    var promoIds = (window.promoBuy1Get2 && window.promoBuy1Get2.productIds) || [];
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = 0;
        cart.items.forEach(function (item) {
          if (promoIds.indexOf(item.product_id) !== -1) {
            total += item.quantity;
          }
        });
        return total;
      });
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var resource = args[0];
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var isAddToCart = url.indexOf('/cart/add') !== -1;

    return originalFetch.apply(this, args).then(function (response) {
      if (isAddToCart && response.ok) {
        response
          .clone()
          .json()
          .then(function (data) {
            var productId = data.product_id || data.id;
            var promoIds = (window.promoBuy1Get2 && window.promoBuy1Get2.productIds) || [];
            if (productId && promoIds.indexOf(productId) !== -1) {
              getPromoQuantityInCart().then(function (totalQty) {
                if (totalQty % 2 !== 0) {
                  openPromoModal();
                }
              });
            }
          })
          .catch(function () {});
      }
      return response;
    });
  };
})();